import React, { useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';
import useAdFree from '../hooks/useAdFree';

interface AdSenseSlotProps {
  client: string; // e.g., ca-pub-XXXXXXXXXXXX
  slot: string;   // e.g., 1182413283
  format?: string; // e.g., 'auto'
  fullWidthResponsive?: boolean;
  style?: React.CSSProperties;
}

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const AdSenseSlot: React.FC<AdSenseSlotProps> = ({
  client,
  slot,
  format = 'auto',
  fullWidthResponsive = true,
  style
}) => {
  const { isAdFree } = useAdFree();
  const ref = useRef<HTMLDivElement>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (isAdFree) return;
    if (initializedRef.current) return;
    // Guard if script not yet present
    if (!window.adsbygoogle) {
      window.adsbygoogle = [];
    }
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      initializedRef.current = true;
    } catch (_) {
      // ignore
    }
  }, [isAdFree]);

  if (isAdFree) {
    return null;
  }

  return (
    <Box ref={ref} w="100%">
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...(style || {}) }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={fullWidthResponsive ? 'true' : 'false'}
      />
    </Box>
  );
};

export default AdSenseSlot;


